import { useTranslate } from "@pathwright/ux/src/components/lng/useTranslate"
import PropTypes from "prop-types"
import { OrderType } from "@pathwright/graphql-client/src/generated"
import { useCurrencyFormatter } from "../../currency/CurrencyFormatterProvider"
import OrderStripeCheckoutForm from "../../order/OrderStripeCheckoutForm"
import { getResourceTypeLabel } from "../../resource/utils"

const LicenseResourceSchoolLicensingForm = ({
  licenseOffering,
  licensorSchool,
  licenseeSchool,
  price,
  discountCode,
  seatCount
}) => {
  const { t, tc } = useTranslate()
  const { currencyFormatter } = useCurrencyFormatter()

  let submitLabel =
    price > 0
      ? t("resource.licensing_form.get_curriculum_payment", {
          payment: currencyFormatter.customFormat(price)
        })
      : t("Get {{ resourceType }}", {
          resourceType: getResourceTypeLabel(
            licenseOffering.resource.resource_type,
            tc
          )
        })

  return (
    <OrderStripeCheckoutForm
      submitLabel={submitLabel}
      orderType={OrderType.CurriculumLicense}
      orderData={{
        license_offering_id: licenseOffering.id,
        licensee_school_id: licenseeSchool.id,
        licensor_school_id: licensorSchool.id,
        name: licenseOffering.resource.name,
        seat_count: seatCount,
        role: "teacher",
        coupon_code: discountCode || undefined
      }}
      stripeApiKey={licensorSchool.stripe_publishable_api_key}
    />
  )
}

LicenseResourceSchoolLicensingForm.displayName =
  "LicenseResourceSchoolLicensingForm"

LicenseResourceSchoolLicensingForm.propTypes = {
  licenseOffering: PropTypes.object.isRequired,
  licensorSchool: PropTypes.object.isRequired,
  licenseeSchool: PropTypes.object.isRequired,
  computedDiscount: PropTypes.object,
  seatCount: PropTypes.number
}

export default LicenseResourceSchoolLicensingForm
